"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClosedAreaSearchV2 = void 0;
const Polygonizer_js_1 = __importDefault(require("jsts/org/locationtech/jts/operation/polygonize/Polygonizer.js"));
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
const GeometryFactory_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/GeometryFactory.js"));
const Vector2D_js_1 = __importDefault(require("jsts/org/locationtech/jts/math/Vector2D.js"));
const ltentity_1 = require("../../cadplugins/cad/ltentity");
const util_1 = require("./util");
const lineWithFeatureId_1 = require("./lineWithFeatureId");
const closedAreaResult_1 = require("./closedAreaResult");
const pointAttach_1 = require("./pointAttach");
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
const lineSegmentAttach_1 = require("./lineSegmentAttach");
const attachDistance = 100;
const angleTolerance = 5 * Math.PI / 180;
class ClosedAreaSearchV2 {
    constructor() {
        this.blockMap = new Map();
    }
    execute(features, geometryParser) {
        //将LTEntityPoint类型和LTPolyline类型分开两个数组
        let lines_LTEntityPoint = new Array();
        let lines_LTPolyline = new Array();
        let lines_LTHatch = new Array();
        let lines_LTLine = new Array();
        let lines_LTArc = new Array();
        let linesArr_doors = new Array();
        //用于记录原要素是否闭合的Map，用于确认在房间内的不规则块到底是柱子还是门（如果是门，算是垃圾数据，但也得考虑）
        let map_isBlockClosed = new Map();
        let map_isClosed = new Map();
        //遍历要素，打散并赋予FeatureId
        for (let feature of features) {
            let geometry = feature.getGeometry();
            if (geometry instanceof ltentity_1.LTEntityPoint) {
                let verticesArray = geometryParser.getLTEntityPointV3(geometry, map_isBlockClosed);
                if (verticesArray) {
                    if (geometryParser._isColumnMap.get(geometry.subData().blockName)) {
                        lines_LTEntityPoint = lines_LTEntityPoint.concat(this.rebuildLinesAndSetFeatureId(verticesArray, feature.id));
                    }
                    else {
                        linesArr_doors.push(this.rebuildLinesAndSetFeatureId(verticesArray, feature.id));
                        //记录是否闭合
                        let isClosed = map_isBlockClosed.get(geometry.subData().blockName);
                        if (isClosed !== undefined)
                            map_isClosed.set(feature.id, isClosed);
                    }
                }
            }
            else if (geometry instanceof ltentity_1.LTPolyline) {
                let ltPoints = geometryParser.getLTPolyline(geometry);
                let isDoor = false;
                //特殊情况处理：围成一圈的多段线判定成门
                if (ltPoints.length == 5) {
                    //图层名包含COLUMN的直接跳过，不做门的判断
                    if (feature.layer.name.toLowerCase().includes("column") === false) {
                        isDoor = true;
                        //边长超过3000的则不算为门
                        for (let i = 0; i < ltPoints.length - 1; i++) {
                            let p1 = new Coordinate_js_1.default(ltPoints[i].x, ltPoints[i].y);
                            let p2 = new Coordinate_js_1.default(ltPoints[i + 1].x, ltPoints[i + 1].y);
                            if (p1.distance(p2) > 3000) {
                                isDoor = false;
                                break;
                            }
                        }
                        //遍历边，要求每个角度都为90°
                        for (let i = 0; i < ltPoints.length - 2; i++) {
                            let p1 = new Coordinate_js_1.default(ltPoints[i].x, ltPoints[i].y);
                            let p2 = new Coordinate_js_1.default(ltPoints[i + 1].x, ltPoints[i + 1].y);
                            let p3 = new Coordinate_js_1.default(ltPoints[i + 2].x, ltPoints[i + 2].y);
                            let v1 = new Vector2D_js_1.default(p2, p1);
                            let v2 = new Vector2D_js_1.default(p2, p3);
                            let angle = v1.angleTo(v2); //范围为-PI~PI
                            if (Math.abs(Math.abs(angle) - Math.PI / 2) > angleTolerance) {
                                isDoor = false;
                                break;
                            }
                        }
                    }
                }
                if (isDoor) {
                    linesArr_doors.push(this.rebuildLinesAndSetFeatureId([ltPoints], feature.id));
                }
                else {
                    lines_LTPolyline = lines_LTPolyline.concat(this.rebuildLinesAndSetFeatureId([ltPoints], feature.id));
                }
            }
            else if (geometry instanceof ltentity_1.LTHatch) {
                let verticesArray = geometryParser.getLTHatch(geometry);
                lines_LTHatch = lines_LTHatch.concat(this.rebuildLinesAndSetFeatureId(verticesArray, feature.id));
            }
            else if (geometry instanceof ltentity_1.LTLine) {
                let ltPoints = geometryParser.getLTLine(geometry);
                lines_LTLine = lines_LTLine.concat(this.rebuildLinesAndSetFeatureId([ltPoints], feature.id));
            }
            else if (geometry instanceof ltentity_1.LTArc) {
                let ltPoints = geometryParser.getLTArc(geometry);
                lines_LTArc = lines_LTArc.concat(this.rebuildLinesAndSetFeatureId([ltPoints], feature.id));
            }
            else {
                if (geometry instanceof ltentity_1.LTText) {
                }
                else {
                    console.log(geometry);
                    console.error("未考虑的类型");
                }
                continue;
            }
        }
        let lines_total = lines_LTEntityPoint.concat(lines_LTPolyline).concat(lines_LTHatch).concat(lines_LTLine).concat(lines_LTArc);
        let lines_door = new Array();
        for (let lines of linesArr_doors) {
            lines_total = lines_total.concat(lines);
            lines_door = lines_door.concat(lines);
        }
        //将LTEntityPoint附着到其他东西上（一般为门）
        geometryParser._doors = [];
        for (let lines of linesArr_doors) {
            let nonAttatch = true;
            for (let targetLine of lines) {
                let adjustedResult = this.attachToAdjustLine(targetLine, lines_total, lines_door);
                let p1_adjusted = adjustedResult.p1_adjusted;
                let p2_adjusted = adjustedResult.p2_adjusted;
                //移除两个端点都附着不到其他东西上的线段
                if (!p1_adjusted && !p2_adjusted) {
                    lines_total.splice(lines_total.indexOf(targetLine), 1);
                }
                else { //有效的门保存起来
                    let sp = targetLine.getStartPoint();
                    let ep = targetLine.getEndPoint();
                    //调整后的门线段有重叠的线段，也有两个端点在一起的无效线段
                    if (!new Coordinate_js_1.default(sp.x, sp.y).equals2D(new Coordinate_js_1.default(ep.x, ep.y), 1e-3)) {
                        let existed = false;
                        let newDoor = new LineSegment_js_1.default(sp.x, sp.y, ep.x, ep.y);
                        for (let door_exist of geometryParser._doors) {
                            if (door_exist.equalsTopo(newDoor)) {
                                existed = true;
                                break;
                            }
                        }
                        if (!existed) {
                            geometryParser._doors.push(newDoor);
                        }
                    }
                    nonAttatch = false;
                }
            }
            if (nonAttatch) {
                let isClosed = map_isClosed.get(lines[0].getFeatureId());
                if (isClosed === true) {
                    //如果该块的所有线段都附着不上，则保留所有的线，但不判定为门
                    lines_total = lines_total.concat(lines);
                }
            }
        }
        let lines = new Array();
        for (let line of lines_total) {
            lines.push([line.getStartPoint(), line.getEndPoint()]);
        }
        //合并邻近的点
        new pointAttach_1.PointAttach().compute(lines);
        lines = new lineSegmentAttach_1.LineSegmentAttach().compute(lines);
        //TODO；现在所有line都只有两个点，这些函数是以前不止两个点的时候的老方法，都可以简化一下
        lines = util_1.Util.fixedPrecisionForAllPoints(lines);
        util_1.Util.removeRepeatSegments(lines);
        //求交
        for (let seg1 of lines) {
            for (let seg2 of lines) {
                if (seg1 === seg2 || util_1.Util.isTwoSegmentsNotInSameRange(seg1, seg2)) {
                    continue;
                }
                //TODO：这里只取了首尾点，是不是有点问题
                let intersectPoint = util_1.Util.computeLineSegmentLineSegmentIntersection(seg1[0], seg1[seg1.length - 1], seg2[0], seg2[seg2.length - 1]);
                if (intersectPoint === undefined) {
                    continue;
                }
                intersectPoint.x = Number(intersectPoint.x.toFixed(4));
                intersectPoint.y = Number(intersectPoint.y.toFixed(4));
                let result1 = util_1.Util.addPointToLine(intersectPoint, seg1);
                let result2 = util_1.Util.addPointToLine(intersectPoint, seg2);
                if (result1 === false || result2 === false) {
                    console.error("求交异常");
                }
            }
        }
        //打断；移除长度为0的无效线段；移除重复线段
        lines = util_1.Util.breakUpToTwoPointsSegments(lines);
        util_1.Util.RemoveZeroLengthSegments(lines);
        util_1.Util.removeRepeatSegments(lines);
        const factory = new GeometryFactory_js_1.default();
        const polygonizer = new Polygonizer_js_1.default();
        for (let line of lines) {
            let arr = new Array();
            for (let point of line) {
                arr.push(new Coordinate_js_1.default(point.x, point.y));
            }
            let lineString = factory.createLineString(arr);
            polygonizer.add(lineString);
        }
        let result = polygonizer.getPolygons();
        return new closedAreaResult_1.ClosedAreaResult(result.toArray(), lines);
    }
    rebuildLinesAndSetFeatureId(polylineArr, featureId) {
        let resultLines = new Array();
        for (let polyline of polylineArr) {
            for (let i = 0; i < polyline.length - 1; i++) {
                let line = new lineWithFeatureId_1.LineWithFeatureId(polyline[i], polyline[i + 1], featureId);
                resultLines.push(line);
            }
        }
        return resultLines;
    }
    attachToAdjustLine(targetLine, lines_total, lines_door) {
        let endPoints = targetLine.getEndPoints();
        let p1_adjusted = false;
        let p2_adjusted = false;
        let p1_adjustedToOtherDoor = false;
        let p2_adjustedToOtherDoor = false;
        for (let j = 0; j < 2; j++) {
            let attachPoint = endPoints[j];
            let minDis = Number.POSITIVE_INFINITY;
            let minDisPoint;
            //遍历其他线段
            let attachToOtherDoor = false;
            for (let otherLine of lines_total) {
                //FeatureId相同则表明是它自身，跳过
                if (targetLine.getFeatureId() === otherLine.getFeatureId()) {
                    continue;
                }
                //不与其他的门附着
                /*if (lines_door.indexOf(otherLine) > -1) {
                  continue;
                }*/
                //计算线段与点的最近点，若距离小于阈值，则将点附着过去
                let closestPoint = otherLine.getClosestPoint(attachPoint);
                let dis = attachPoint.getDistanceTo(closestPoint);
                if (dis >= 0 && dis < attachDistance) {
                    if (dis < minDis) {
                        minDis = dis;
                        minDisPoint = closestPoint;
                        attachToOtherDoor = lines_door.indexOf(otherLine) > -1;
                    }
                }
            }
            if (minDisPoint) {
                if (j == 0) {
                    p1_adjusted = true;
                    p1_adjustedToOtherDoor = attachToOtherDoor;
                }
                else {
                    p2_adjusted = true;
                    p2_adjustedToOtherDoor = attachToOtherDoor;
                }
                attachPoint.x = minDisPoint.x;
                attachPoint.y = minDisPoint.y;
            }
        }
        //在只有一边附着到东西的前提下
        //如果两边都附着了门，则保留下来
        //如果只有其中一边附着了门，则移除掉
        if ((p1_adjusted !== p2_adjusted) && (p1_adjustedToOtherDoor !== p2_adjustedToOtherDoor)) {
            p1_adjusted = false;
            p2_adjusted = false;
        }
        return {
            p1_adjusted: p1_adjusted,
            p2_adjusted: p2_adjusted
        };
    }
}
exports.ClosedAreaSearchV2 = ClosedAreaSearchV2;
